export default __webpack_public_path__ + "static/media/Seul sur la dune - II.0557cb11.jpg";